import Navbar from "./ui/navbar";
import Footer from "./ui/footer";
import Home from "./modules/Home";
import About from "./modules/About";
import Products from "./modules/Products";
import Services from "./modules/Services";
import Contacts from "./modules/Contacts";
import AuthReseller from "./modules/AuthReseller";

function App() {
  return (
    <div className="flex flex-col w-full h-full min-h-screen bg-[#FFFFFF]">
      <Navbar />
      <Home />
      <AuthReseller />
      <About />
      <Services />
      <Products />
      <Contacts />
      <Footer />
    </div>
  );
}

export default App;
